
import { DOMAIN_CONFIG, IS_LOCALHOST, isSaaSPlatform, isStandalonePortfolio } from '../config/domainConfig';

/**
 * Global App Configuration based on Domain
 * Allows the same codebase to run as "SyncZ Portfolio" (.net), "SyncZ Marketplace" (.app), or "Portal"
 */

export const getAppMode = (): 'PORTFOLIO' | 'MARKETPLACE' | 'PORTAL' => {
    // 1. Check Build-Time Flag (For Production Deployment)
    const buildMode = (import.meta as any).env?.VITE_APP_MODE;
    
    // 2. Runtime Domain Check
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

    // Explicit Marketplace Subdomain
    if (hostname === DOMAIN_CONFIG.SAAS_MARKETPLACE) {
        return 'MARKETPLACE';
    }

    // MARKETPLACE / LANDING / ADMIN for SaaS root domain
    if (isSaaSPlatform(hostname)) {
        return 'MARKETPLACE';
    }

    // PORTAL GATEWAY (Exact Match of Base)
    // e.g. p.syncz.work -> Shows Login/Find Workspace only
    if (hostname === DOMAIN_CONFIG.SAAS_PORTAL_BASE || hostname === `portal.${DOMAIN_CONFIG.SAAS_ROOT}`) {
        return 'PORTAL';
    }

    // TENANT PORTFOLIO (Subdomain or Custom)
    // e.g. neon.p.syncz.work OR myportfolio.com
    if (
        hostname.endsWith(`.${DOMAIN_CONFIG.SAAS_PORTAL_BASE}`) ||
        hostname.includes('c-syncz') || 
        hostname.includes('syncz-portal') ||
        isStandalonePortfolio(hostname)
    ) {
        return 'PORTFOLIO';
    }

    // Localhost / Preview Development
    if (buildMode === 'SAAS') return 'MARKETPLACE';
    if (buildMode === 'PORTAL') return 'PORTAL'; 
    return 'PORTFOLIO';
};

export const isStripeEnabled = (): boolean => {
    return getAppMode() === 'PORTFOLIO';
};

export const getAppTitle = (): string => {
    const mode = getAppMode();
    const hostname = window.location.hostname;
    
    if (mode === 'MARKETPLACE') return 'SyncZ App';
    if (mode === 'PORTAL') return 'SyncZ Portal';
    if (isStandalonePortfolio(hostname)) return 'SyncZ Portal';
    
    return 'Portfolio Portal';
};

export const isPublicPagesDisabledByDefault = (): boolean => {
    return (import.meta as any).env?.VITE_DISABLE_PUBLIC_PAGES === 'true';
};

